import React, { useCallback, useEffect, useRef } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { CheckBoxLabel } from 'components/CheckBoxLabel'

import type {
  EditBookingFormValues,
  EditBookingResolverContext,
} from '../../../utils/editBookingValidation'

import styles from './index.module.css'
import { buildTimeOptions } from './util'

type Props = {
  form: UseFormReturn<EditBookingFormValues, EditBookingResolverContext>
  disabled: boolean
}

export const EntryInstructionSection: React.FC<Props> = ({ form, disabled }) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = form
  const values = watch()

  const prevSkipRef = useRef<boolean>(values.skipInstructionTime)

  // skipInstructionTime が ON に切り替わった瞬間に日時を空にする
  useEffect(() => {
    if (!prevSkipRef.current && values.skipInstructionTime) {
      setValue('driverDateTime', '', { shouldDirty: true })
      setValue('driverCombinedTime', '', { shouldDirty: true })
    }
    prevSkipRef.current = values.skipInstructionTime
  }, [values.skipInstructionTime, setValue])

  const handleClear = useCallback(() => {
    setValue('driverDateTime', '', { shouldDirty: true })
    setValue('driverCombinedTime', '', { shouldDirty: true })
    setValue('skipInstructionTime', false, { shouldDirty: true })
  }, [setValue])

  const fieldsDisabled = disabled || values.skipInstructionTime

  return (
    <div className={styles.subSection}>
      <div className={styles.fieldList}>
        <div className={styles.field}>
          <CheckBoxLabel
            label="指示を受けていない"
            disabled={disabled}
            {...register('skipInstructionTime')}
          />
        </div>

        <div className={styles.row}>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="driverDateTime">
              指示日
            </label>
            <input
              id="driverDateTime"
              type="date"
              className={styles.input}
              disabled={fieldsDisabled}
              {...register('driverDateTime')}
            />
          </div>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="driverCombinedTime">
              指示時間
            </label>
            <select
              id="driverCombinedTime"
              className={styles.timeSelect}
              disabled={fieldsDisabled}
              {...register('driverCombinedTime')}
            >
              <option value="">--:--</option>
              {buildTimeOptions(values.driverCombinedTime).map((t) => (
                <option
                  key={t}
                  value={t}
                  style={t.endsWith(':00') ? { fontWeight: 700 } : undefined}
                >
                  {t}
                </option>
              ))}
            </select>
          </div>
        </div>
        {errors.driverCombinedTime && (
          <span className={styles.errorText}>{errors.driverCombinedTime.message}</span>
        )}

        <div className={styles.inlineActions}>
          <button
            type="button"
            className={styles.clearButton}
            onClick={handleClear}
            disabled={disabled}
          >
            クリア
          </button>
        </div>
      </div>
    </div>
  )
}
